import uniqBy from 'lodash.uniqby';
import groupBy from 'lodash.groupby';

const getWalkwayDistance = route =>
  route.originalRoute.movements
    .filter(movement => movement.type === 'walkway')
    .reduce((sum, movement = 0) => sum + (movement.total_duration || 0), 0);

const getDuration = (route, isPedestrian) =>
  isPedestrian ? route.total_duration : getWalkwayDistance(route);

const getRouteFromTypeAndFastDuration = (routes, isPedestrian) => {
  const sortRoutes = routes.filter(route => isPedestrian === route.pedestrian);

  sortRoutes.reverse((a, b) => {
    if (getDuration(a) < getDuration(b)) {
      return -1;
    }
    if (getDuration(a) > getDuration(b)) {
      return 1;
    }
    return 0;
  });

  return sortRoutes.length > 0 ? sortRoutes[0] : null;
};

const routesSorting = payload => {
  const routes = Object.values(
    groupBy(payload.flat(2), routes => routes.startPointName)
  ).map(routesStartPoint => {
    const pedestrianRoute = getRouteFromTypeAndFastDuration(
      routesStartPoint,
      true
    );

    if (pedestrianRoute && pedestrianRoute.total_duration <= 600) {
      return pedestrianRoute;
    }

    const transportRoute = getRouteFromTypeAndFastDuration(
      routesStartPoint,
      false
    );

    if (transportRoute) {
      return transportRoute;
    }

    return pedestrianRoute;
  });

  const uniqueMetro = uniqBy(routes, route => route.startPointName);
  const unique = uniqBy(uniqueMetro, route => route.routeId);

  return unique;
};

export default routesSorting;
